<template>
  <div class="playControl">
    <div class="playControl_inn">
      <audio :src="songUrl" ref="audio"
             id="audio"
             @timeupdate="timeupdateFunc"
             @error="errorFunc"
             @ended="endPlay" @play="playFunc" @pause="pauseFunc"
             @canplay="canplayFunc"
             :loop="false"
      ></audio>
      <div class="control_out">
        <div class="lock">
          <i class="iconfont  icon-bar_icon_lock_"></i>
        </div>
        <div class="posi_re">
          <div class="control">
            <div class="con_l flex_c">
              <router-link :to="{name:'songDetail'}" class="ro" v-if="musicList.length>0">
                <div class="icon-cover el-flex" @click="toSongDetail">
                  <span class="iconku icon" :class="iconName"></span>
                </div>
                <img v-lazy="songInfo.pic" :alt="songInfo.name" :key="songInfo.pic"
                     class="song_img">
              </router-link>
              <router-link :to="{name:'songDetail'}" class="ro" v-else>
                <div class="icon-cover el-flex" @click="toSongDetail">
                  <span class="iconku icon" :class="iconName"></span>
                </div>
                <img src="../../assets/images/nosong_.png" class="song_img">
              </router-link>
              <div>
                <div class="el-flex info_con">
                  <div class="info">
                    <div v-if="musicList.length>0&&songInfo.name!==''">
                      <span class="song_name" :title="songInfo.name">{{ songInfo.name }}</span>
                      <span class="artist" :title="songInfo.artist" @click="toSingerDetail(songInfo.artistid)">&nbsp;- {{
                          songInfo.artist
                        }}</span>
                    </div>
                    <div v-else>酷我音乐-陪着我·不要停</div>
                  </div>
                  <span class="time" v-if="musicList.length==0">00:00/00:00</span>
                  <span class="time" v-else>{{ setting.nowTime }}/{{ setting.duration }}</span>
                </div>
                <el-slider v-model="value1"
                           style="margin-top: -15px;"
                           :disabled="isDisabled"
                           :show-tooltip="false"
                           @change="setProcessFunc"
                           @mousedown.native="isDragging=true"
                           @mouseup.native="isDragging=false"
                           :format-tooltip="formatTooltip"
                ></el-slider>
              </div>
            </div>
            <div class="con_c el-flex">
              <div class="prev" title="上一首" @click="pre">
                <i class="iconfont icon-bar_icon_pre_"></i>
              </div>
              <div class="play" title="播放">
                <i class="iconfont icon-bar_icon_pause_" v-if="isPlay" @click="pauseMusic"></i>
                <i class="iconfont icon-bar_icon_play_1" v-else @click="playMusic"></i>
              </div>
              <div class="next" title="下一首" @click="next">
                <i class="iconfont icon-bar_icon_next_"></i>
              </div>
            </div>
            <div class="con_r flex_c">
              <i class="iconfont icon-heart icon prev" title="收藏歌曲" v-if="getSongIndex({rid:song.id})"  @click="deleteLoveItem(songInfo)"></i>
              <i class="iconfont icon-list_icon_heart prev" title="收藏歌曲" v-else @click="getLoveItem(songInfo)"></i>
              <i class="prev iconfont icon-bar_icon_download_" title="下载歌曲"></i>
              <i class="prev iconfont icon-lyric_icon_comment_" title="评论"></i>
              <span class="playt">
                <i class="prev iconfont icon-bar_icon_loop_" title="循环播放" v-if="mode==1" @click="changeMode"></i>
                <i class="prev iconfont icon-bar_icon_repeat_" title="单曲循环" v-if="mode==2" @click="changeMode"></i>
                <i class="prev iconfont icon-bar_icon_list_" title="顺序播放" v-if="mode==3" @click="changeMode"></i>
                <i class="prev iconfont icon-bar_icon_random_" title="随机播放" v-if="mode==4" @click="changeMode"></i>
              </span>
              <span class="playList">
                <span class="play_count" @click="isShow = !isShow">{{ musicList.length }}</span>
                <i class="prev iconfont icon-bar_icon_playlistfuzhi" title="歌曲列表" @click="isShow = !isShow"></i>
              </span>
              <div class="song_type">
                <span title="品质">高品</span>
                <i class="iconfont icon-bar_icon_arrow_"></i>
                <div class="type_out">
                  <ul class="items">
                    <li>无损</li>
                    <li class="active">高品</li>
                  </ul>
                </div>
              </div>
              <i class="iconfont icon-bar_icon_mute" title="音量" v-if="false"></i>
              <i class="iconfont icon-bar_icon_volume_" title="音量"></i>
              <div class="volume">
                <div class="progress_bar">
                  <div class="bar_inner">
                    <div class="progress" style="width: 43px;"></div>
                    <div class="progress_btn_wrapper"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="song_list" v-if="isShow">
            <div class="list_top el-flex">
              <div>
                <span class="text">播放列表</span>
                <span class="num">(共{{ musicList.length }}首)</span>
              </div>
              <div class="el-flex">
                <div class="clear_all" @click="clearMusics">
                  <i class="iconfont icon-list_clean_n"></i>
                  <span class="clear_btn">清空列表</span>
                </div>
                <i class="close iconfont icon-list_icon_x" @click="isShow = !isShow"></i>
              </div>
            </div>
            <div class="list_con" :class="{'hasmusic':musicList.length!==0}">
              <div v-if="musicList.length!==0">
                <div class="flex_c list_item"
                     :class="{'active_cur':song.id==item.rid}"
                     style="pointer-events: auto;" v-for="(item,index) in musicList" :key="index">
                  <div class="list_idx">
                    {{ index + 1 }}
                    <span class="playing" v-if="song.id==item.rid">
                      <span class="side1 pause"></span>
                      <span class="side2 pause"></span>
                      <span class="side3 pause"></span>
                    </span>
                  </div>
                  <div class="song_name">
                    <span :title="item.name" @click="setMusic(item)">{{ item.name }}</span>
                  </div>
                  <div class="artist text-ellipsis">
                    <router-link :to="{name:'singerDetail',query:{id:item.artistid}}" :title="item.artist">{{ item.artist }}</router-link>
                  </div>
                  <div class="time">{{ item.songTimeMinutes }}</div>
                  <div class="song_opts flex_c">
                    <i class="iconfont icon-playlist_icon_add_" title="添加歌曲"></i>
                    <i class="iconfont icon-heart icon" title="收藏歌曲" v-if="getSongIndex({rid:item.rid})" @click="deleteLoveItem(item)"></i>
                    <i class="iconfont icon-list_icon_heart" title="收藏歌曲" v-else @click="getLoveItem(item)"></i>
                    <i class="iconfont icon-bar_icon_download_" title="下载歌曲"></i>
                    <i class="iconfont icon-playlist_icon_trash_" title="删除歌曲" @click="deleteSongItem(item)"></i>
                  </div>
                </div>
              </div>
              <div class="no_data" v-else>
                <img src="../../assets/images/nomic.png" alt="">
                <p>您还没有添加任何歌曲</p>
                <p>去首页
                  <router-link :to="{path:'/'}" class="nuxt-link-active">
                    发现音乐
                  </router-link>
                  ，添加自己喜欢的歌曲吧~
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import useSettingStore from "@/store/modules/setting";
import userTrackStore from "@/store/modules/track";
import {ref, reactive, watch, onMounted} from "vue";
import {voiceDuration} from "@/utils/voiceDuration";
import {storeToRefs} from 'pinia'
import {getSongUrl, getMusicInfo} from "@/http/api";
import {useRouter,useRoute} from "vue-router";
import useMySongStore from "@/store/modules/mySongList";
import useAudioStore from "@/store/modules/audio";
import useHistoryStore from "@/store/modules/history";
const $router = useRouter()
const $route = useRoute()
let isDisabled = ref()
let iconName = ref('')
const TrackStore = userTrackStore()
const SettingStore = useSettingStore()
const MySongStore = useMySongStore()
const AudioStore = useAudioStore()
const localMusicListStore = useHistoryStore()
let {mode} = storeToRefs(SettingStore)
let {musicList, song} = storeToRefs(TrackStore)
const changeMode = () => {
  SettingStore.changeMode()
}
const toSongDetail = () => {
  if (iconName.value=='ku-zhankai'){
    $router.back()
  }
}
watch(()=>$route.path,(newVal)=>{
  if (newVal.indexOf('songDetail')!=-1){
    iconName.value = 'ku-zhankai'
  }else {
    iconName.value = 'ku-z045'
  }
},{immediate:true})
const deleteLoveItem = (item) => {
  MySongStore.deleteSongItem(item)
}
const getSongIndex = (song_item) => {
  return MySongStore.musicList.some(item => item.rid == song_item.rid)
}
const getLoveItem = (item) => {
  MySongStore.setSongItem(item)
}
const setMusic = (item) => {
  TrackStore.setMusic(item)
}
const clearMusics = () => {
  TrackStore.RemoveMusicList()
  songUrl.value = ''
  songInfo.value = {}
  isPlay.value = false
  AudioStore.clearAudio()
}
const toSingerDetail = (id) => {
  $router.push({name: 'singerDetail', query: {id: id}})
}
const deleteSongItem = (item) => {
  TrackStore.deleteSongItem(item)
}
watch(() => musicList.value.length, (newVal) => {
  isDisabled.value = newVal === 0;
},{immediate:true})
watch(() => song.value.id, (newVal) => {
  if (newVal == '') {
    pauseMusic()
    setTimeout(() => {
      value1.value = 0
      setting.nowTime = '00:00'
    }, 100)
    return
  }
  reqSongUrl()
  setTimeout(() => {
    playMusic()
  }, 800)
})
let setting = reactive({
  nowTime: '00:00',
  duration: '00:00',
  totalTimes: null,
})
let songInfo = ref({})
let isDragging = ref(false)
let isShow = ref(false)
let audio = ref(null)
let isPlay = ref(false)
let value1 = ref(0)
let songUrl = ref()
const timeupdateFunc = (e) => {
  if (!isDragging.value) {
    value1.value = (e.target.currentTime) / setting.totalTimes * 100
  }
}
const next = () => {
  if (mode.value == 1 || mode.value == 3) {
    audio.value.pause()
    let list = TrackStore.musicList
    if (list.length == 0) return
    else if (list.length==1){
      setting.nowTime = '00:00'
      audio.value.load()
      audio.value.play()
    }else {
      let index = TrackStore.musicList.map(item => item.rid).indexOf(TrackStore.song.id)
      index += 1
      if (index == TrackStore.musicList.length) index = 0
      TrackStore.setNowSong(TrackStore.musicList[index].rid)
    }
  } else if (mode.value == 4) {
    let index = parseInt(Math.random() * TrackStore.musicList.length)
    TrackStore.setNowSong(TrackStore.musicList[index].rid)
  } else if (mode.value == 2) {
    setting.nowTime = '00:00'
    audio.value.load()
    audio.value.play()
  }
}
const pre = () => {
  if (mode.value == 1) {
    audio.value.pause()
    let list = TrackStore.musicList
    if (list.length == 0) return
    else if (list.length==1){
      setting.nowTime = '00:00'
      audio.value.load()
      audio.value.play()
    }else {
      let index = TrackStore.musicList.map(item => item.rid).indexOf(TrackStore.song.id)
      index -= 1
      if (index < 0) index = TrackStore.musicList.length - 1
      TrackStore.setNowSong(TrackStore.musicList[index].rid)
    }
  } else if (mode.value == 4) {
    let index = parseInt(Math.random() * TrackStore.musicList.length)
    TrackStore.setNowSong(TrackStore.musicList[index].rid)
  } else if (mode.value == 2) {
    setting.nowTime = '00:00'
    audio.value.load()
    audio.value.play()
  }
}
const reqSongUrl = async () => {
  if (TrackStore.song.id == '') return
  let result = await getSongUrl(TrackStore.song.id)
  if (result.data.data !== '') {
    songUrl.value = result.data.data
  }
  AudioStore.getAudio(audio.value)
  let result_ = await getMusicInfo(TrackStore.song.id)
  songInfo.value = result_.data.data
  audio.value.loop = false;
}
const endPlay = () => {
  value1.value = 0
  setting.nowTime = '00:00'
  if (mode.value == 3) {
    let index = TrackStore.musicList.map(item => item.rid).indexOf(TrackStore.song.id)
    if (index == TrackStore.musicList.length - 1) {
      audio.value.pause()
    } else {
      next()
    }
  } else {
    next()
  }
}
const playFunc = () => {
  isPlay.value = true
}
const errorFunc = () => {
  reqSongUrl()
  setTimeout(() => {
    playMusic()
  }, 500)
}
const pauseFunc = () => {
  isPlay.value = false
}
const canplayFunc = (e) => {
  setting.totalTimes = e.target.duration;
  setting.duration = voiceDuration(e.target.duration * 1000)
}
const pauseMusic = () => {
  // isPlay.value = false
  audio.value.pause()
}
const setProcessFunc = (val) => {
  setting.nowTime = voiceDuration(Math.round(val / 100 * audio.value.duration * 1000))
  audio.value.currentTime = Math.round(val / 100 * audio.value.duration)
  isDragging.value = false
}
const formatTooltip = (val) => {
  if (val == 0 || val == null) return
  setting.nowTime = voiceDuration(Math.round(val / 100 * audio.value.duration * 1000))
}
const playMusic = () => {
  if (isDisabled.value) return
  // isPlay.value = true
  AudioStore.getAudio(audio.value)
  audio.value.play()
  localMusicListStore.addLocalMusicList(songInfo.value)
}
onMounted(() => {
  reqSongUrl()
})
</script>

<style scoped lang="scss">
:deep(.el-slider__button), :deep(.hover), :deep(.dragging) {
  cursor: pointer !important;
}

:deep(.el-slider__button) {
  width: 16px !important;
  height: 16px !important;
}

.playControl {
  position: fixed;
  left: 0;
  z-index: 11000;
  bottom: 0;
  padding-top: 20px;
  height: 90px;
  width: 100%;

  .flex_c {
    display: flex;
    align-items: center;
  }

  .playControl_inn {
    background: #fff;
    box-shadow: 0 0 20px 0 rgb(0 0 0 / 10%);

    .control_out {
      position: relative;
      max-width: 1640px;
      padding: 0 120px;
      margin: 0 auto;
      background: #fff;

      .lock {
        position: absolute;
        bottom: 69px;
        right: 110px;
        height: 40px;
        width: 80px;
        background: url(../../assets/images/pic_lockbg.png) 0 -8px no-repeat;
        text-align: center;
        z-index: 999;

        i {
          position: relative;
          cursor: pointer;
          font-size: 20px;
          top: 19px;
          left: 2px;
        }
      }

      .posi_re {
        position: relative;

        .control {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .con_l {
            flex-shrink: 0;
            position: relative;
            width: 460px;

            .cover {
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              right: 0;
              z-index: 101;
            }

            .ro {
              width: 70px;
              height: 70px;
              margin-right: 20px;
              position: relative;
              &:hover{
                .icon-cover{
                  display: flex;
                }
              }
              .icon-cover{
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                width: 70px;
                height: 70px;
                display: none;
                position: absolute;
                background-color: rgba(73, 86, 96,.4);
                .icon{
                  color: white;
                  font-size: 20px;
                }

              }
              img {

                width: 70px;
                height: 70px;
              }
            }

            .info_con {
              width: 370px;
              justify-content: space-between;
              margin-bottom: 11px;

              .info {
                font-size: 14px;
                width: 290px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;

                .song_name, .artist {
                  display: inline-block;
                  vertical-align: middle;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }

                .song_name {
                  max-width: 53.67%;
                  line-height: 22px;
                }

                .artist {
                  max-width: 31.63%;
                  color: #666;
                  cursor: pointer;
                }
              }

              .time {
                font-size: 14px;
                color: #999;
              }
            }

            .process {
              width: 370px;

              .progress_bar {
                position: relative;
                width: 100%;
                height: 3px;
                background: rgba(0, 0, 0, .05);
                border-radius: 2px;
                cursor: pointer;

                .bar_inner {
                  position: absolute;
                  top: 0;
                  left: 0;
                  display: flex;
                  align-items: center;

                  .progress {
                    background: #ffdf1f;
                    height: 3px;
                    border-radius: 2px;
                  }

                  .progress_btn_wrapper {
                    position: absolute;
                    z-index: 100;
                    right: -4px;
                    width: 12px;
                    height: 12px;
                    top: -4px;
                    background: #fff;
                    box-shadow: 0 0 15px 0 rgb(0 0 0 / 15%);
                    border-radius: 50%;

                    &:after {
                      position: absolute;
                      content: " ";
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      width: 4px;
                      height: 4px;
                      background: #ffdf1f;
                      border-radius: 50%;
                    }
                  }
                }
              }
            }

          }

          .con_c {
            flex-shrink: 0;
            color: #333;

            .prev {
              width: 28px;
              text-align: center;
              cursor: pointer;
              font-size: 24px;

              i {
                font-size: 24px;
              }
            }

            .play {
              width: 46px;
              text-align: center;
              cursor: pointer;
              margin: 0 31px;

              i {
                font-size: 40px;
              }
            }

            .next {
              width: 28px;
              text-align: center;
              cursor: pointer;

              i {
                font-size: 24px;
              }
            }
          }

          .con_r {
            display: flex;
            justify-content: flex-end;
            width: 460px;
            color: #666;
            flex-shrink: 0;

            .icon-bar_icon_heart_ {
              margin-left: 0;
            }

            .iconfont {
              font-size: 18px;
              margin-left: 28px;
              cursor: pointer;
              color: #666;
            }

            .playList {
              position: relative;

              .play_count {
                position: absolute;
                text-align: center;
                top: -4px;
                left: 37px;
                padding: 0 2px;
                font-size: 12px;
                background: #fff;
                cursor: pointer;
              }
            }

            .song_type {
              position: relative;
              flex-shrink: 0;
              width: 58px;
              height: 24px;
              line-height: 18px;
              border-radius: 13px;
              margin-left: 31px;
              font-size: 12px;
              border: 1px solid #666;

              span {
                margin-left: 11px;
                display: inline-block;
                vertical-align: middle;
              }

              .icon-bar_icon_arrow_ {
                font-size: 16px;
                vertical-align: middle;
                margin-left: 0;
              }

              .type_out {
                position: absolute;
                left: -58px;
                bottom: 100%;
                display: none;
                padding-bottom: 15px;
                z-index: 10000;

                .items {
                  padding: 5px 0;
                  width: 174px;
                  background: #fff;
                  box-shadow: 0 4px 20px 0 rgb(65 67 70 / 8%);

                  li {
                    height: 42px;
                    line-height: 42px;
                    padding-left: 18px;
                    font-size: 14px;
                    cursor: pointer;
                    color: #333;
                  }

                  .active {
                    background: #ffdf1f;
                    font-weight: 600;
                  }
                }
              }
            }

            .volume {
              display: flex;
              align-self: center;
              width: 86px;
              margin-left: 10px;

              .progress_bar {
                position: relative;
                width: 100%;
                height: 3px;
                background: rgba(0, 0, 0, .05);
                border-radius: 2px;
                cursor: pointer;

                .bar_inner {
                  position: absolute;
                  top: 0;
                  left: 0;
                  display: flex;
                  align-items: center;

                  .progress {
                    background: #ffdf1f;
                    height: 3px;
                    border-radius: 2px;
                  }

                  .progress_btn_wrapper {
                    position: absolute;
                    z-index: 100;
                    right: -4px;
                    width: 12px;
                    height: 12px;
                    top: -4px;
                    background: #fff;
                    box-shadow: 0 0 15px 0 rgb(0 0 0 / 15%);
                    border-radius: 50%;

                    &:after {
                      position: absolute;
                      content: " ";
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      width: 4px;
                      height: 4px;
                      background: #ffdf1f;
                      border-radius: 50%;
                    }
                  }
                }
              }
            }
          }
        }

        .song_list {
          position: absolute;
          right: 14%;
          bottom: 80px;
          width: 512px;
          background: #fff;
          padding: 34px 0 20px;
          box-shadow: 0 4px 20px 0 rgb(65 67 70 / 8%);

          .list_top {
            justify-content: space-between;
            padding: 0 23px 0 25px;

            .text {
              font-size: 16px;
              height: 22px;
              font-weight: 600;
            }

            .num {
              margin-left: 5px;
              font-size: 14px;
              font-weight: 300;
            }

            .clear_all {
              position: relative;
              margin-right: 21px;

              .icon-list_clean_n {
                font-size: 20px;
                vertical-align: middle;
                cursor: pointer;
              }

              .clear_btn {
                display: inline-block;
                cursor: pointer;
              }
            }

            .close {
              font-size: 20px;
              cursor: pointer;
            }
          }

          .hasmusic {
            overflow: auto;
          }

          .list_con {
            max-height: 414px;
            margin-top: 20px;

            .no_data {
              margin: 119px 0;
              text-align: center;

              p {
                color: #999;
                line-height: 24px;

                .nuxt-link-active {
                  color: #296294;
                }
              }

            }

            &::-webkit-scrollbar {
              width: 6px;
              height: 2px;
            }

            &::-webkit-scrollbar-thumb {
              border-radius: 10px;
              background: rgba(127, 127, 127);
            }

            .active_cur {
              background: hsla(0, 0%, 96.9%, .7);
            }

            .list_item {
              font-size: 14px;
              height: 46px;
              padding: 0 25px;

              &:hover {
                .song_opts {
                  display: flex;
                }

                .time {
                  display: none;
                }
              }

              .list_idx {
                position: relative;
                min-width: 16px;
                height: 20px;
                text-align: center;
                margin-right: 8px;
                line-height: 20px;

                .playing {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 20px;
                  height: 16px;
                  line-height: 14px;
                  text-align: center;
                  background: #f7f7f7;

                  span {
                    position: absolute;
                    bottom: 0;
                    width: 2px;
                    background: #ffe200;
                  }

                  .side1 {
                    left: 2px;
                    height: 6px;
                    -webkit-animation: first-data-v-bdf3ddae 1s linear infinite;
                    animation: first-data-v-bdf3ddae 1s linear infinite;
                  }

                  .side2 {
                    left: 6px;
                    height: 4px;
                    -webkit-animation: second-data-v-bdf3ddae 1s linear infinite;
                    animation: second-data-v-bdf3ddae 1s linear infinite;
                  }

                  .side3 {
                    left: 10px;
                    height: 6px;
                    -webkit-animation: middle-data-v-bdf3ddae 1s linear infinite;
                    animation: middle-data-v-bdf3ddae 1s linear infinite;
                  }

                  .pause {
                    -webkit-animation-play-state: paused;
                    animation-play-state: paused;
                  }
                }

              }

              .song_name {
                min-width: 198px;
                height: 20px;
                font-weight: 400;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                line-height: 20px;
                margin-right: 22px;

                span {
                  cursor: pointer;
                }
              }

              .artist {
                width: 163px;
                height: 20px;
                font-weight: 400;
                line-height: 20px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                a {
                  color: #666;
                }
              }

              .time {
                margin-left: 16px;
                height: 16px;
                line-height: 16px;
                font-weight: 600;
              }

              .song_opts {
                flex: 1;
                display: none;
                text-align: right;

                i {
                  cursor: pointer;
                  margin-left: 13px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
